export { default } from "./StarRatings";
